import { Pipe, PipeTransform } from "@angular/core";
import { CertificationType } from "@app/training/training.models";

@Pipe({ name: "certTypeName" })
export class CertTypeNamePipe implements PipeTransform {
	transform(certType: CertificationType): string {
		return CertificationType.getPrettyName(certType);
	}
}
